import { network } from "../network/network.js";
export async function searchPages(query) {
    let _query = { ...query };
    if (Array.isArray(query.tags)) {
        _query.tags = query.tags.join(",");
    }
    if (Array.isArray(query.childOf)) {
        _query.childOf = query.childOf.join(",");
    }
    return await network("/pages", { query: _query });
}
